import ArticleLibrary from "../sites/article_library/index.tsx";

import { setSlimRequireContext } from "../shared/scripts/utils/react_rails";

setSlimRequireContext(require.context("components", true));

ArticleLibrary();
